import SyncedTranscript from './SyncedTranscript'
import { Button, Card, CardContent, CardHeader, CardTitle } from '@mytours/components'
import strings from '../../../strings'
import { getDirMode } from '../../platform'

interface Props {
	onClose: () => void
	transcription?: string
	transcriptionFormat?: 'html' | 'timecoded'
	mediaItemId?: number
	currentTime: number
	isPlaying: boolean
}

/**
 * The transcript modal body shared by the video card preview and the fullscreen
 * player: a titled, dismissible card wrapping a SyncedTranscript. Each caller
 * renders it inside its own <Modal>.
 */
const TranscriptModalCard = ({
	onClose,
	transcription,
	transcriptionFormat,
	mediaItemId,
	currentTime,
	isPlaying,
}: Props): JSX.Element => (
	<Card variant="ios" dir={getDirMode()} className="synced-transcript-modal-card">
		<CardHeader>
			<CardTitle as="h2" id="dialogTitle">
				{strings.transcript}
			</CardTitle>
			<Button variant="clear" className="close" onClick={onClose} aria-label={strings.close}>
				<i className="fal fa-xmark" />
			</Button>
		</CardHeader>
		<CardContent>
			<SyncedTranscript
				variant="modal"
				transcription={transcription}
				transcriptionFormat={transcriptionFormat}
				mediaItemId={mediaItemId}
				currentTime={currentTime}
				isPlaying={isPlaying}
			/>
		</CardContent>
	</Card>
)

export default TranscriptModalCard
